<script setup lang="ts">
import Button from './Button.vue';

defineProps<{
    href?: string;
    target?: string;
    type?: 'button' | 'submit' | 'reset';
    pill?: boolean;
}>();
</script>

<template>
    <Button
        :href="href"
        :target="target"
        :type="type"
        :pill="pill"
        :class="{
            'bg-(--az-red-600) outline-(--az-red-500) hover:bg-(--az-red-700)': true,
            'font-semibold text-white': true,
        }"
    >
        <slot />
    </Button>
</template>
